import { render, staticRenderFns } from "./BoardNightsPersonsOverview.vue?vue&type=template&id=c2a20b94&"
import script from "./BoardNightsPersonsOverview.vue?vue&type=script&lang=js&"
export * from "./BoardNightsPersonsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports